import { getTranslatedText, withErrorBoundary } from '@nile/components';
import { SVGIcon } from '@superops/super-icons';
import { Button } from '@superops/ui-design-system';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';

const DefaultAction = ({
  label,
  icon,
  variant,
  onClick,
  client,
  query,
  getVariables,
  onCompleted,
  onError,
  data,
  defaultLabel,
  variables,
  template,
  checkIsDisabled,
  updateCache,
  defaultAction = () => {}
}) => {
  const [loading, setLoading] = useState(false);

  const handleMutation = async () => {
    let variablesData = variables;
    if (getVariables) {
      variablesData = getVariables({ data, template });
    }
    try {
      setLoading(true);
      const res = await client.mutate({
        mutation: query,
        variables: variablesData,
        update: (result, cache) => {
          if (updateCache) {
            updateCache(result, cache);
          }
        }
      });
      if (onCompleted) {
        onCompleted(res);
      }
    } catch (error) {
      if (onError) {
        onError(error);
      }
    } finally {
      setLoading(false);
    }
  };

  const handleClick = () => {
    if (onClick) {
      onClick();
      return;
    }
    if (client && query) {
      handleMutation();
      return;
    }
    defaultAction();
  };

  const getIsDisabled = () => {
    if (checkIsDisabled) {
      return checkIsDisabled({ data, template });
    }
    return false;
  };

  const isDisabled = getIsDisabled();

  return (
    <Button
      icon={icon && <SVGIcon name={icon} />}
      {...variant}
      onClick={handleClick}
      loading={loading}
      disabled={isDisabled}
    >
      {label || defaultLabel}
    </Button>
  );
};

const Actions = ({
  primaryActionComponent,
  secondaryActionComponent,
  primaryAction,
  secondaryAction = {},
  data,
  defaultSecondaryAction,
  template,
  primaryActionProps = {},
  secondaryActionProps = {},
  updateTabProperty
}) => {
  const intl = useIntl();
  const PrimaryActionComponent = primaryActionComponent || DefaultAction;
  const SecondaryActionComponent = secondaryActionComponent;
  return (
    <div className="flex actr tw-gap-x-2">
      <div>
        {secondaryActionComponent ? (
          <SecondaryActionComponent
            data={data}
            {...secondaryActionProps}
            updateTabProperty={updateTabProperty}
          />
        ) : (
          <DefaultAction
            {...secondaryAction}
            data={data}
            defaultAction={defaultSecondaryAction}
            variant={{ plainSecondary: true }}
            defaultLabel={getTranslatedText(intl, 'common.cancel')}
            template={template}
          />
        )}
      </div>
      <div>
        {primaryActionComponent ? (
          <PrimaryActionComponent
            data={data}
            {...primaryActionProps}
            updateTabProperty={updateTabProperty}
          />
        ) : (
          <DefaultAction
            {...primaryAction}
            data={data}
            variant={{ primary: true }}
            defaultLabel={getTranslatedText(intl, 'common.save')}
            template={template}
          />
        )}
      </div>
    </div>
  );
};

export default withErrorBoundary(Actions);
